export default function ($mdDialog) {
    "ngInject";

    var vm = this;

    vm.confirmInput = "";
    vm.isConfirmActionDisabled = isConfirmActionDisabled;
    vm.cancel = $mdDialog.hide;
    vm.confirm = confirm;

    function isConfirmActionDisabled() {
        if (!vm.requiresConfirmWord) {
            return false;
        }
        return vm.confirmInput !== (vm.confirmWord || "RESET");
    }

    function confirm() {
        $mdDialog.hide(true);
    }
}
